import React from 'react';
import logo from '../../assets/logo.png';

export const Logo: React.FC = () => {
  return (
    <div className="flex flex-col items-center gap-1 sm:gap-2 text-[#5CD2F4] p-2">
      <div className="flex items-center gap-0 text-2xl sm:text-3xl font-bold tracking-wider">
        <img
          src={logo}
          alt="NuroLeap Logo"
          className="h-6 sm:h-8 w-auto object-contain mx-[-2px]"
        />
      </div>
    </div>
  );
};